const AccountStatusEnum = Object.freeze({
    ACTIVE: 'ACTIVE',
    DORMANT: 'DORMANT',
    SUSPENDED: 'SUSPENDED',
    CLOSED: 'CLOSED'
});

export default AccountStatusEnum;
